import Axios from "axios";
import BigNumber from "bignumber.js";
import { OrderedMap } from "immutable";
const tokenDecimals = (token) => {
    switch (token) {
        case "BTC":
            return 8;
        case "ZEC":
            return 8;
        case "BCH":
            return 8;
        case "DAI":
            return 18;
        case "ETH":
            return 18;
        case "REN":
            return 18;
        default:
            throw new Error(`Unknown token ${token}`);
    }
};
// CoinGecko price feed
const coinGeckoURL = `https://api.coingecko.com/api/v3`;
const coinGeckoID = (token) => {
    switch (token) {
        case "BTC":
            return "bitcoin";
        case "ZEC":
            return "zcash";
        case "BCH":
            return "bitcoin-cash";
        case "DAI":
            return "dai";
        case "ETH":
            return "ethereum";
        case "REN":
            return "republic-protocol";
        default:
            throw new Error(`Unknown token ${token}`);
    }
};
const coinGeckoParams = `localization=false&tickers=false&market_data=true&community_data=false&developer_data=false&sparkline=false`;
const getCoinGeckoPrice = (token) => Axios
    .get(`${coinGeckoURL}/coins/${coinGeckoID(token)}?${coinGeckoParams}`)
    .then(response => response.data.market_data.current_price.usd || 0);
// Coinbase price feed
const coinbaseURL = (token) => `https://api.coinbase.com/v2/prices/${token.toUpperCase()}-USD/buy`;
const getCoinbasePrice = (token) => Axios
    .get(coinbaseURL(token))
    .then(response => parseInt(response.data.data.amount, 10) || 0);
// const coinMarketCapID = (token: string): number => {
//     /*
//     In order to fetch the code of a currency, use:
//     ```js
//     let x;
//     Axios({
//         method: "GET",
//         url: "https://pro-api.coinmarketcap.com/v1/cryptocurrency/map",
//         params: {
//             "symbol": "BTC,ZEC,BCH"
//         },
//         headers: {
//             [`X-CMC` + `_PRO_API_KEY`]: "..."
//         },
//     }).then(r => { x = r.data.data; }).catch(console.error);
//     console.debug(x.filter(row => ["BTC", "ZEC", BCH"].includes(row.symbol)))
//     ```
//     */
//     switch (token) {
//         case "BTC":
//             return 1;
//         case "ZEC":
//             return 1437;
//         case "BCH":
//             return 1831;
//         default:
//             throw new Error(`Unknown token ${token}`);
//     }
// };
// const getCoinMarketCapPrice: PriceFeed = (token: string) =>
//     Axios.request({
//         url: "https://pro-api.coinmarketcap.com/v1/cryptocurrency/listings/latest",
//         method: "GET",
//         params: {
//             "start": `${coinMarketCapID(token)}`,
//             "limit": "1",
//             // "convert": "USD,BTC"
//         },
//         headers: {
//             // Free-tier CMC API key.
//             [`X-CMC` + `_PRO_API_KEY`]: `${24874700}-${1064}-447d-9daa-3fd514863f67`
//         },
//     }).then((response: { data: { data: Array<{ symbol: string, quote: { USD: { price: number } } }> } }) => { return response.data.data.filter(x => x.symbol === token)[0].quote.USD.price; });
export const getTokenPrices = async (tokens, logger) => {
    try {
        return await tokens.map((token) => ({
            token,
            priceFeeds: [
                getCoinGeckoPrice(token),
                getCoinbasePrice(token),
            ],
        }))
            .reduce(async (pricesPromise, { token, priceFeeds }) => {
            const prices = await pricesPromise;
            const returnedAPIs = [];
            for (const priceFeed of priceFeeds) {
                try {
                    returnedAPIs.push(await priceFeed);
                }
                catch (error) {
                    // tslint:disable-next-line: no-console
                    if (logger)
                        logger.error(error);
                }
            }
            return prices.set(token, returnedAPIs.length ?
                returnedAPIs.reduce((sum, price) => sum + price, 0) / returnedAPIs.length :
                0);
        }, Promise.resolve(OrderedMap()));
    }
    catch (error) {
        if (logger)
            logger.error(error);
        return OrderedMap();
    }
};
export const normalizeValue = (prices, token, value) => {
    const shiftedValue = new BigNumber(value).div(new BigNumber(10).exponentiatedBy(tokenDecimals(token)));
    const timesPrice = shiftedValue.times(prices.get(token, 0));
    return timesPrice;
};
//# sourceMappingURL=data:application/json;base64,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